import React, { useEffect, useState } from 'react';
import './App.css';

function App() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className={`app ${visible ? 'visible' : ''}`}>
      <div className="noise"></div>
      <header className="header">
        <div className="logo">isandex</div>
        <div className="status-pill">
          <span className="dot" />
          Coming soon
        </div>
      </header>

      <main className="main">
        <div className="eyebrow">Introducing</div>
        <h1 className="headline">
          <span className="word">Escu</span>
          <span className="word accent">chas</span>
        </h1>
        <p className="subheading">
          Something new is being built.<br />
          Stay close — we'll let you know when it's ready.
        </p>

        <form
            className="notify-form"
            onSubmit={(e) => {
              e.preventDefault();
              const input = e.target.elements.email;
              if (input.value) {
                input.value = '';
                input.placeholder = 'You\'re on the list ✓';
                input.disabled = true;
                e.target.querySelector('button').disabled = true;
              }
            }}
          >
            <input
              type="email"
              name="email"
              placeholder="your@email.com"
              required
              className="email-input"
            />
            <button type="submit" className="notify-btn">
              Notify me
            </button>
        </form>
      </main>

      <footer className="footer">
        <span>© {new Date().getFullYear()} Isandex</span>
        <span className="separator">·</span>
        <span>All rights reserved</span>
      </footer>
    </div>
  );
}

export default App;
